(function () {
  'use strict';

  const SWIPE_MIN_PX = 50;

  // SVG icons for mute button
  const ICON_UNMUTED = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
  </svg>`;

  const ICON_MUTED = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
  </svg>`;

  // ── VIDEO VISIBILITY + MUTE BUTTON ──────────────────────────────────────────

  function initVideoSlides(slideshowEl) {
    const slider = slideshowEl.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = Array.from(slideshowEl.querySelectorAll('.slideshow__slide'));

    // Inject mute toggle into each slide that has a video
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;

      // Ensure the media wrapper is positioned for absolute button
      const mediaWrapper = slide.querySelector('.slideshow__media');
      if (mediaWrapper) mediaWrapper.style.position = 'relative';

      const btn = document.createElement('button');
      btn.className = 'slideshow__video-mute';
      btn.setAttribute('aria-label', 'Unmute video');
      btn.innerHTML = ICON_MUTED; // starts muted

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        btn.innerHTML = video.muted ? ICON_MUTED : ICON_UNMUTED;
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      (mediaWrapper || slide).appendChild(btn);
    });

    // IntersectionObserver: play video when slide is visible, pause when not
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { root: slider, threshold: 0.5 }
    );

    slides.forEach((slide) => observer.observe(slide));
  }

  // ── SWIPE SUPPORT ───────────────────────────────────────────────────────────

  function addSwipe(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    let x0 = 0;
    let y0 = 0;
    let tracking = false;

    slider.addEventListener(
      'touchstart',
      (e) => {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      (e) => {
        if (!tracking) return;
        const dx = Math.abs(e.touches[0].clientX - x0);
        const dy = Math.abs(e.touches[0].clientY - y0);
        // If scrolling more vertically than horizontally, cancel swipe
        if (dy > dx) tracking = false;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchend',
      (e) => {
        if (!tracking) return;
        tracking = false;
        const delta = e.changedTouches[0].clientX - x0;
        if (Math.abs(delta) < SWIPE_MIN_PX) return;
        const btnName = delta < 0 ? 'next' : 'previous';
        component.querySelector(`button[name="${btnName}"]`)?.click();
      },
      { passive: true }
    );
  }

  function addSwipeIfNeeded(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;
    // Skip if native overflow scroll is already handling swipe (mobile sliders)
    const overflow = window.getComputedStyle(slider).overflowX;
    if (overflow === 'scroll' || overflow === 'auto') return;
    addSwipe(component);
  }

  // ── INIT ────────────────────────────────────────────────────────────────────

  function init() {
    // Slideshow: always needs both video handling and JS swipe
    document.querySelectorAll('slideshow-component').forEach((el) => {
      initVideoSlides(el);
      addSwipe(el); // slideshow uses programmatic scrollTo, needs JS swipe
    });

    // Generic sliders: only add JS swipe where CSS native scroll isn't active
    document.querySelectorAll('slider-component').forEach((el) => {
      addSwipeIfNeeded(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
